<template>
    <div class="Login">
        <header-view></header-view>
        <div class="container_w clear">
            <div class="login_box right">
                <h3>Login</h3>
                <div class="input_text clear" :class="{'active_line':personalCheck}">
                    <i class="personal_icon"></i>
                    <input type="text" placeholder="FFP /ID/Phone Number" v-model="personalvalue">
                    <p v-if="personalCheck">Input cannot be empty.</p>
                </div>
                <div class="input_text clear" :class="{'active_line':passwordCheck}">
                    <i class="password_icon"></i>
                    <input :type="showpass?'password':'text'" placeholder="Password" v-model="passwordvalue" @input='search'>
                    <span v-if="passwordvalue != ''" class="left" :class="{'password_eyeopen':showpass}" @click="showHideEye"></span>
                    <p v-if="passwordCheck">Account and password do not match.</p>
                </div>
                <div class="remember_l">
                    <span :class="{'fxsel_active':fxselState}" @click="checkFxsel"></span>
                    Remember Me
                </div>
                <div class="btn_login">
                    <button @click="goLogin">Login</button>
                </div>
            </div>
        </div>
        <footer-view></footer-view>
    </div>
</template>

<script>
import HeaderView from "@/components/Header/Header";
import FooterView from "@/components/Footer/Footer";
export default {
  components: {
   HeaderView,
   FooterView
  },
  name: "Login",
  data() {
    return {
        fxselState:false,
        personalCheck:false,
        passwordCheck:false,
        showpass:false,
        personalvalue:'',
        passwordvalue:''
    };
  },
  props: {},
  watch: {},
  methods: {
    checkFxsel(){
        console.log(this.fxselState)
        this.fxselState = !this.fxselState
    },
    goLogin(){
        console.log(this.personalvalue+'-----'+this.passwordvalue)
    },
    showHideEye(){
        this.showpass = !this.showpass
    },
    search(){
        let sP = false
        if(this.passwordvalue.length){
            sP = true
        }
        this.showpass = sP
    }

  },
  filters: {},
  computed: {},
  created() {
    
  },
  mounted() {
      console.log(this.personalvalue+'-----'+this.passwordvalue)
  },
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
  .Login{
        height: 648px;
        background: url(../../assets/login/pic_content_login_bg.png) no-repeat center;
    //   background-size: cover;
        .login_box{
            margin-top: 72px;
            width:560px;
            height:504px;
            background:rgba(255,255,255,1);
            box-shadow:0px 4px 24px 0px rgba(0,0,0,0.1);
            border-radius:8px;
            padding: 88px 64px;
            h3{
                font-size:24px;
                color:rgba(51,51,51,1);
                line-height:29px;
                margin-bottom: 48px;
            }
            .input_text{
                position: relative;
                // height: 48px;
                border-bottom: 1px solid #ECEEF0;
                margin-bottom: 32px;
                i{
                    position: absolute;
                    top: 12px; 
                    left: 0;
                    width: 24px;
                    height: 24px;
                }
                p{
                    position: absolute;
                    right: 0;
                    bottom: -21px;
                    font-size:14px;
                    color:rgba(216,0,15,1);
                }
                .personal_icon{
                    background: url(../../assets/login/icon_content_login_personal.png) no-repeat center;
                }
                .password_icon{
                    &::before{
                        content: '';
                        position: relative;
                        display: inline-block;
                        top: -1px;
                        left: 50%;
                        margin-left: -5px;
                        width:10px;
                        height:10px;
                        border:2px solid rgba(191,191,191,1);
                    }
                    background: url(../../assets/login/icon_content_login_password.png) no-repeat center;
                }
                span{
                    position: absolute;
                    right: 0;
                    top: 12px;
                    width: 24px;
                    height: 24px;
                    background: url(../../assets/login/ic_content_login_eyeclose.png) no-repeat center;
                }
                .password_eyeopen{
                    background: url(../../assets/login/ic_content_login_eyeopen.png) no-repeat center;
                }
                input{
                    width: 100%;
                    padding: 0 32px;
                    line-height: 48px;
                    font-size:16px;
                    color:#333333;
                }
            }
            .active_line{
                border-bottom: 2px solid #D8000F;
            }
            .remember_l{
                padding-top: 10px;
                font-size:16px;
                color:rgba(128,128,128,1);
                margin-bottom: 16px;
                span{
                    float: left;
                    cursor: pointer;
                    width: 24px;
                    height: 24px;
                    background: url(../../assets/login/icon_com_choose_fxdisable.png) no-repeat center;
                    margin-right: 9px;
                }
                .fxsel_active{
                    background: url(../../assets/login/icon_com_choose_fxsel.png) no-repeat center;
                }
            }
            .btn_login{
                button{
                    width: 100%;
                    height:48px;
                    background:rgba(216,0,15,1);
                    border-radius:4px;
                    font-size:16px;
                    color:rgba(255,255,255,1);
                }
            }
        }
  }
</style>
